import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-event-link' })
export class EventComponent {
	constructor(private element: HTMLElement) {
		this.onEventClick();
	}

	onEventClick() {
		this.element.addEventListener('click', (event) => {
			event.stopPropagation();
			const target = this.element.getAttribute('data-link');
			if (target) {
				window.open(target, '_blank');
			}
		});
	}
}
